import React, { useEffect } from "react";
import { Spin } from "antd";
import { resolveNewFrontendHref } from "../../../app/navigation/new-frontend-href";

/**
 * 旧关联查询地址一律进新页。菜单、收藏、手输和工作台「合同全览」都走这里。
 */
export default function RelationshipDashboardRedirect() {
    useEffect(() => {
        window.location.replace(resolveNewFrontendHref("/contract-management/relationship-dashboard"));
    }, []);

    return (
        <div className="page-container">
            <div style={{ textAlign: "center", padding: 48 }}>
                <Spin />
                <div style={{ marginTop: 12 }}>正在打开新的关联查询…</div>
            </div>
        </div>
    );
}
